// extracted by mini-css-extract-plugin
var _1 = "OlIna";
var _2 = "MHDaP";
export { _1 as "badgeStyle", _2 as "notificationButton" }
